<template>
  <div>
   <PostingPeriod/>
  </div>
</template>

<script>
import PostingPeriod from '../../../../components/tax/payments/utils/PostingPeriod/PostingPeriod.vue';

export default {
  name: 'postingperiod',
  components: {
    PostingPeriod,
  },
};
</script>
